// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/**
 * Finerty design tokens — TypeScript mirror for JS-land consumers
 * (chart libraries, canvas, email previews) that cannot read CSS
 * custom properties.
 *
 * The values MUST match src/tokens.css — enforced by
 * src/__tests__/parity.test.ts. For styling React components, prefer the
 * CSS custom properties / Tailwind utilities over these constants.
 */

export const colors = {
  purplePrimary: '#2D0A6C',
  purple05: '#D5CEE2',
  lilac04: '#E5E3FF',
  lilac05: '#F2F1FF',
  lilac06: '#F8F8FF',

  black: '#141414',
  white: '#FFFFFF',
  grey01: '#333333',
  grey02: '#666666',
  grey03: '#999999',
  grey04: '#525252',
  grey05: '#E5E5E5',
  neutral05: '#E7E7E7',
  grey06: '#F4F4F4',
  pageBg: '#FAFAFA',
  rowHover: '#F8F9FA',

  secondaryText: '#313957',
  errorText: '#96040E',
  errorBg: '#FEEEEE',
  successText: '#004E24',
  successBg: '#EAFAEF',
  neutralText: '#193CB8',
  neutralBg: '#E5EFFB',
  warningBg: '#F9F6D3',
  warningText: '#733F01',
  avatarBg: '#FFDA8B',
  avatarText: '#5A0000',
} as const;

/**
 * Categorical palette for charts (pie/donut/bar series), anchored on the
 * brand purple. Extracted from the advisor Financial Position dashboard.
 */
export const chartPalette = [
  colors.purplePrimary,
  '#A78BFA',
  '#7C5CFC',
  '#BDB8FF',
  '#4C1D95',
  '#C4B5FD',
] as const;

export type ColorToken = keyof typeof colors;
